<div class="add-invoice-modal" *transloco="let t; prefix: 'maintenanceCosting.modals.addInvoice'">
  <div class="add-invoice-modal__header">
    <h3 class="add-invoice-modal__title">{{ t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <form [formGroup]="invoiceForm" class="add-invoice-modal__form">
    <div class="form-step">
      <div class="form-group">
        <label class="form-label">{{ t('fields.asset') }} <span class="required">*</span></label>
        <app-account-asset-scope-selector
          [placeholder]="t('placeholders.asset')"
          selectionMode="asset-only"
          (scopeChange)="onScopeChange($event)">
        </app-account-asset-scope-selector>
      </div>

      <div class="form-group">
        <label for="category" class="form-label">{{ t('fields.category') }} <span class="required">*</span></label>
        <input
          type="text"
          id="category"
          formControlName="category"
          class="form-control"
          [placeholder]="t('placeholders.category')">
      </div>

      <div class="form-group">
        <label for="description" class="form-label">{{ t('fields.description') }}</label>
        <textarea
          id="description"
          formControlName="description"
          class="form-control form-textarea"
          rows="3"
          [placeholder]="t('placeholders.description')"></textarea>
      </div>

      <div class="form-group">
        <app-flatpickr-date-picker
          [label]="t('fields.date')"
          [required]="true"
          [(value)]="date"
          [disabled]="false"
          [allowPastDates]="true">
        </app-flatpickr-date-picker>
      </div>

      <div class="form-group">
        <label for="invoiceNumber" class="form-label">{{ t('fields.invoiceNumber') }}</label>
        <input
          type="text"
          id="invoiceNumber"
          formControlName="invoiceNumber"
          class="form-control"
          [placeholder]="t('placeholders.invoiceNumber')">
      </div>

      <div class="form-group">
        <label class="form-label">{{ t('fields.uploadInvoice') }}</label>

        <div class="invoice-upload">
          <span class="invoice-upload__name" [class.invoice-upload__name--empty]="!invoiceFileName">
            {{ invoiceFileName || t('noFileSelected') }}
          </span>

          <input
            type="file"
            hidden
            #invoiceInput
            [accept]="acceptedInvoiceTypes"
            (change)="onInvoiceSelected($event)">

          <button
            type="button"
            class="invoice-upload__button"
            [disabled]="!selectedAssetId || isUploadingInvoice || isSaving"
            (click)="invoiceInput.click()">
            @if (isUploadingInvoice) {
              <span class="spinner-border spinner-border-sm"></span>
            } @else {
              <span>{{ t('upload') }}</span>
            }
          </button>
        </div>

        @if (!selectedAssetId) {
          <span class="invoice-upload__hint">{{ t('selectAssetFirst') }}</span>
        }
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="cost" class="form-label">{{ t('fields.cost') }} <span class="required">*</span></label>
          <input
            type="text"
            id="cost"
            formControlName="cost"
            class="form-control"
            placeholder="{{ currencySymbol }}6835">
        </div>

        <div class="form-group">
          <label for="odometer" class="form-label">{{ t('fields.odometer') }} <span class="required">*</span></label>
          <input
            type="text"
            id="odometer"
            formControlName="odometer"
            class="form-control"
            placeholder="985 000">
        </div>
      </div>

      <div class="form-group">
        <label for="notes" class="form-label">{{ t('fields.notes') }}</label>
        <textarea
          id="notes"
          formControlName="notes"
          class="form-control form-textarea"
          rows="3"
          [placeholder]="t('placeholders.notes')"></textarea>
      </div>
    </div>
  </form>

  <div class="add-invoice-modal__actions">
    <button type="button" class="btn-cancel" (click)="cancel()" [disabled]="isSaving">
      <span>{{ 'common.cancel' | transloco }}</span>
    </button>
    <button type="button" class="btn-save" (click)="save()" [disabled]="!canSave">
      @if (isSaving) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        <span>{{ t('submit') }}</span>
      }
    </button>
  </div>
</div>